import React, { useCallback, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useRouter } from 'next/router'

import { ProfileViewComponent } from 'components/Providers/ProfileView'
import { NehrProvidersComponent } from 'components/Providers/index.nehr'

import BookingActions from 'stores/Booking/Actions'
import {
  bookAppointmentStatusSelector,
  bookApppointmentLoadingSelector,
  bookingDataLoadingSelector,
  bookingDataSelector
} from 'stores/Booking/Select'
import useCheckingEnrSigned from 'hooks/useCheckingEnrSigned'

export const ProfileViewContainer = ({ provider, isCareTeam = false }) => {
  const dispatch = useDispatch()
  const router = useRouter()

  const { isEhrSigned } = useCheckingEnrSigned()
  const isBookingDataLoading = useSelector(bookingDataLoadingSelector)
  const bookingData = useSelector(bookingDataSelector)
  const isBookAppointmentLoading = useSelector(bookApppointmentLoadingSelector)
  const bookAppointmentStatus = useSelector(bookAppointmentStatusSelector)

  const [isEhrRequired, setIsEhrRequired] = useState(false)
  const [isOpenModal, setIsOpenModal] = useState(false)

  const goToProviders = useCallback(
    () => {
      router.back()
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  )

  const getBookingData = useCallback(
    (providerId, locationId) => {
      dispatch(BookingActions.getBookingData(providerId, locationId))
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  )

  const bookAppointment = useCallback(
    (providerId, locationId, timeslotId) => {
      dispatch(
        BookingActions.bookAppointment(providerId, locationId, timeslotId)
      )
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  )

  const resetBooking = useCallback(
    () => {
      dispatch(BookingActions.resetBooking())
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  )

  const openBookingCheck = useCallback(() => {
    setIsEhrRequired(true)
    return isEhrSigned
  }, [isEhrSigned])

  const openBookingModal = useCallback(
    () => {
      setIsOpenModal(true)
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  )

  const goToMessages = useCallback(
    () => {
      router.push({
        pathname: '/notifications',
        query: { isOpenComposeMessage: true }
      })
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  )

  return isEhrSigned || !isEhrRequired ? (
    <ProfileViewComponent
      isCareTeam={isCareTeam}
      goToProviders={goToProviders}
      provider={provider}
      openBookingModal={openBookingModal}
      goToMessages={goToMessages}
      isBookingDataLoading={isBookingDataLoading}
      bookingData={bookingData}
      getBookingData={getBookingData}
      isBookAppointmentLoading={isBookAppointmentLoading}
      bookAppointmentStatus={bookAppointmentStatus}
      bookAppointment={bookAppointment}
      resetBooking={resetBooking}
      openBookingCheck={openBookingCheck}
      isOpenModal={isOpenModal}
      setIsOpenModal={setIsOpenModal}
    />
  ) : (
    <NehrProvidersComponent isEhrSigned={isEhrSigned} />
  )
}
